import React, { useState } from "react";
import styled from "styled-components";
import DisputesList from "../../components/Disputes/DisputesList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DisputesActions from "../../store/actions/Disputes";
import { Heading } from "../../constants/assets/containers";
import { FlexContainer } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import BulkRevertDispute from "../../components/Disputes/BulkRevertDisputes";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";

const statesToReset = [
  "filters",
  "disputesList",
  "nextPage",
  "prevPage",
];

const Index = ({
  getDisputesList,
  disputesList,
  filters,
  resetState,
}) => {

  const [modalstate, setModalState] = useState(false)
  const allActions = MenuActionsMappings[MenuNames.DISPUTES];
  const handleClick = () => {
    setModalState(true);
  };

  const handleClose = () => {
    setModalState(false);
  };

  const applyFilters = (filters) => {
    let newFilters = { ...filters };
    newFilters["page"] = 1;
    delete filters.page;
    getDisputesList(newFilters);
  };

  const clearFilters = () => {
    statesToReset.forEach((state) => resetState(state));
  };

  const getFilters = () => {
    const updatedObj = { ...filters };
    delete updatedObj.page;
    return updatedObj;
  };

  return (
    <div class="">
      <FlexContainer align="flex-start">
        <Heading>Disputes</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.BULK_UPLOAD]}>
            <Button
              onClick={() => handleClick()}
              className="sushi-btn ml-12"
              data-testid="BulkUploadTagsBtn"
            >
              Bulk Revert Disputes
            </Button>
          </Permission>
          {modalstate &&
            <BulkRevertDispute
              handleClose={handleClose}
              sendExtraAck={true}
              action="quality_DisputeBulkRevert"
              serviceOwner="quality_service"
              sampleURL="/sample/bulk_revert_disputes.csv"
              useUserUploadedFilename={true} />}
        </div>
      </FlexContainer>
      <DisputesView>
        <DisputesList
          clearFilters={clearFilters}
          list={disputesList}
          applyFilters={applyFilters}
          allFilters={getFilters()}
        />
      </DisputesView>
    </div>
  );
};


const DisputesView = styled.section`
  height: unset;
`;

function mapStateToProps(state) {
  const { Disputes } = state;
  return {
    disputesList: Disputes.DisputesList,
    filters: Disputes.Filters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDisputesList: bindActionCreators(
      DisputesActions.getDisputesList,
      dispatch
    ),
    resetState: bindActionCreators(DisputesActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
